/** Workspace “all trades” sentinel (empty select value). */
export const SERVICE_TRADE_ALL_LABEL = "All trades";

export const SERVICE_TRADE_UNKNOWN = "Unknown";

export interface ServiceTradeOption {
  value: string;
  label: string;
}

function isUnknownTrade(value: string): boolean {
  return value.trim().localeCompare(SERVICE_TRADE_UNKNOWN, undefined, {
    sensitivity: "accent",
  }) === 0;
}

/**
 * Keep API count ordering for named trades, but always pin `Unknown` last
 * (overrides the backend `ORDER BY cnt DESC` rank for that bucket).
 */
export function sortServiceTradeSuggestions(
  rows: ServiceTradeOption[],
): ServiceTradeOption[] {
  const known: ServiceTradeOption[] = [];
  const unknown: ServiceTradeOption[] = [];
  for (const row of rows) {
    if (isUnknownTrade(row.value) || isUnknownTrade(row.label)) {
      unknown.push(row);
    } else {
      known.push(row);
    }
  }
  return [...known, ...unknown];
}
